import { render } from "./FooterApp.vue?vue&type=template&id=93039580&scoped=true"
const script = {}

import "./FooterApp.vue?vue&type=style&index=0&id=93039580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93039580"]])

export default __exports__